import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate, sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';

import { TDocument, uhdrsMotorScore } from '../utils';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';

const sort = (type: string, documents?: IOwnProps['documents']): TDocument[] | undefined => {
  if (documents) {
    return documents
      .sort((n1, n2) => sortPartialDate(n2.date, n1.date) || n2._cdate - n1._cdate)
      .filter(d => d._type === type, documents);
  } else return undefined;
};

const MotorFuncHuntDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const uhdrsDoc = sort('uhdrsMotorRatingScale', documents) as IUHDRSMotorRatingScale[];
  return (
    <TileContentMaker
      type="recentList"
      data={uhdrsDoc.map(u => ({
        date: isPartialDate(u.date) ? formatPartialDate(u.date) : '',
        title: <FormattedMessage id="motorFunctionHuntington.uhdrs" />,
        value:
          uhdrsMotorScore(u) === 'notCounted' || uhdrsMotorScore(u) === 'cantCount' ? '-' : `${uhdrsMotorScore(u)}`,
        key: u._id,
      }))}
    />
  );
};

interface IOwnProps {
  documents: Array<TDocument>;
}

export default MotorFuncHuntDash;
